import {FC} from 'react'

import {useClientLogos} from '@/content/clientLogos'
import {useHomepageContent} from '@/content/homepage'
import {Trans, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {LogoCarousel} from '../common/carousel/LogoCarousel'
import {Logo} from '../common/carousel/types'
import {Text, TextFontWeight, TextVariant} from '../common/content/Text'
import {TrustpilotCard} from '../common/statistics/TrustpilotCard'
import {usePreferences} from '../context/Preferences'

type OurClientsAndStatisticsProps = {
  numOfRegisteredTrademarks: number
  backgroundColor?: string
  logos?: Logo[]
  title?: string
  marginTop?: string
  hasBoxShadow?: boolean
  boxShadowColor?: string
  backgroundOverlay?: {color: string; heightRatio: number}
}

export const OurClientsAndStatistics: FC<React.PropsWithChildren<OurClientsAndStatisticsProps>> = ({
  numOfRegisteredTrademarks,
  backgroundColor = theme.palette.background.butter,
  logos,
  title,
  marginTop,
  hasBoxShadow = false,
  boxShadowColor,
  backgroundOverlay,
}) => {
  const {t} = useTranslation()

  const {clientsTitle} = useHomepageContent()
  const {origin} = usePreferences()
  const defaultClientLogos = useClientLogos(origin)
  const clientLogos = logos || defaultClientLogos

  return (
    <>
      <TrustpilotCard
        header={
          <Text
            variant={TextVariant.h5}
            element="h2"
            align="center"
            fontWeight={TextFontWeight.regular}
          >
            <Text variant={TextVariant.h5} element="span" fontWeight={TextFontWeight.bold}>
              {numOfRegisteredTrademarks}
            </Text>{' '}
            <Trans
              t={t}
              i18nKey={title ?? clientsTitle}
              values={{count: numOfRegisteredTrademarks}}
            />
          </Text>
        }
        backgroundColor={backgroundColor}
        hasBoxShadow={hasBoxShadow}
        boxShadowColor={boxShadowColor}
        backgroundOverlay={backgroundOverlay}
        hasNarrowPadding
        marginTop={marginTop}
      >
        <div className="clients-carousel">
          <LogoCarousel logos={clientLogos} />
        </div>
      </TrustpilotCard>

      <style jsx>{`
        .clients-carousel {
          min-width: 0;
          max-width: 760px;
        }
        @media ${TABLET_SCREENSIZE} {
          .clients-carousel {
            max-width: 100%;
          }
        }
      `}</style>
    </>
  )
}
